import { writable } from 'svelte/store';
import { tick } from 'svelte';
export const darkModeClass = writable('');
export const renderDarkMode = writable(false);
export const marginClass = writable('');



let darkModeSwitch = 0;

function inDNApp() {
  //console.log('inDNAp');
  try {
      return !(typeof window.ReactNativeWebView === 'undefined' || window.ReactNativeWebView === null);
  } catch (e) {
      return false;
  }
}


function isNewerVersion(oldVer, newVer) {
  const oldParts = oldVer.split('.')
  const newParts = newVer.split('.')
  for (let i = 0; i < newParts.length; i++) {
    const a = ~~newParts[i]
    const b = ~~oldParts[i]
    if (a > b) return true
    if (a < b) return false
  }
  return false
}

function handleMargins() {
  //console.log('handleMargins');
  return getUrlVars().dnApp && isNewerVersion('6.0.1', getUrlVars().dnAppVersion);
}

function isNewWidget(darkModeSettings){
    // has widget darkModeSettings
    if( typeof darkModeSettings === 'undefined' || darkModeSettings === null || darkModeSettings === '' ){
      return false;
    }
    if ( (darkModeSettings === 'Följ användarens tema' || darkModeSettings === 'Alltid ljus' || darkModeSettings === 'Alltid mörk') ) {
      return true;
    } else {
      return false;
    }
  }

export function getUrlVars() {
    //console.log('getUrlVars');
    let vars = {};
  
    window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, (m, key, value) => {
      vars[key] = value;
    });
  
    return vars;
  }
  
export async function handleDarkModeSettings(adaptedForDarkMode,allwaysDark,darkModeSettings){

  if (arguments.length === 1) {
    darkModeSettings = adaptedForDarkMode;
    adaptedForDarkMode = false;
    allwaysDark = false;
  } 

  let appDarkMode = false;

  if (getUrlVars().darkMode) {
        appDarkMode = getUrlVars().darkMode === "1";
  }

  // is new widget with drop down
  if( isNewWidget(darkModeSettings) ) {

    if( darkModeSettings === 'Följ användarens tema') {
      
      adaptedForDarkMode = true;

    } 
    
    if(darkModeSettings === 'Alltid ljus') {
      
      adaptedForDarkMode = false;
      allwaysDark = false;

    } 

    if( darkModeSettings === 'Alltid mörk') {
      
      adaptedForDarkMode = false;
      allwaysDark = true;

    } 
  }

  // alltid mörk
  if ( allwaysDark ){
    darkModeSwitch = 3;
  }

  // darkmode
  if ( (adaptedForDarkMode && appDarkMode) && !allwaysDark){
    darkModeSwitch = 2;
  }
  
  // lightmode
  if ( (adaptedForDarkMode && !appDarkMode) && !allwaysDark){
    darkModeSwitch = 0;
  }

  // alltid ljus
  if (!adaptedForDarkMode && !allwaysDark ){
    darkModeSwitch = 1;
  }

  /* 
   0 = lightmode
   1 = alltid ljus
   2 = darkmode
   3 = alltid mörk
    */


   darkModeClass.set(getDarkModeClass() + getDebugIfNotDN());
   renderDarkMode.set(useDarkMode());
   marginClass.set(handleMargins() ? "main__padded-width" : "main__normal-width" );
   await tick();
}

export const isForcedColorMode = () => {
if(darkModeSwitch  === 1 || darkModeSwitch  === 3){
  return true;
} else {
  return false;
}
}

export const useDarkMode = () => {
  if(darkModeSwitch > 1 ){
    return true;
  } else {
    return false;
  }
  
};

const getDarkModeClass = () => {

  if(darkModeSwitch === 0 ){

    return "main__light-mode";

  } else if (darkModeSwitch === 1) {

    return 'main__light-mode main__padded-top-bottom';

  } else if (darkModeSwitch === 2) {

      return "main__dark-mode";

  } else if (darkModeSwitch === 3) {

    return 'main__dark-mode main__padded-top-bottom';

  } else {

    return '';
  }
  
};


const getDebugIfNotDN = () => {

  try {
      if (inDNApp()){return ""}
      if (window.top !== window.self) {
          const parentDomain = document.referrer ? new URL(document.referrer).hostname : "";
          if (!parentDomain.includes("dn.se")) {
              return " debug-class";
          }
          return "";
      }
      return " debug-class";
  } catch (error) {
      console.error("Kunde inte kontrollera parent-domänen:", error);
      return " debug-class";
  }
  return " debug-class";
}